<template>
    <div class="object">
        <img class="cup" src="@/assets/img/cup/cup.png" alt="">
        <img class="shadow" src="@/assets/img/cup/shadow.png" alt="">
    </div>
</template>

<script>
export default {
    name: 'cup',
    data(){
        return{
            
        }
    }
    
}
</script>

<style lang="scss" scoped>
    .object{
        @extend %flex;
        position: relative;
        img{
            position: absolute;
            &.cup{
                z-index: 1;
            }
            &.shadow{
                z-index: 0;
                mix-blend-mode: multiply;
                @media #{$IE}{
                    opacity: 0;
                }
                @supports not (mix-blend-mode: multiply){
                    opacity: 0;
                }
            }
        }
    }
</style>